<template>
    <div id="adjust">
        <a-modal
            :title="$t('pubGicSet.Adjust')"
            :visible="visible"
            width="85%"
            @cancel="handleCancel"
            :maskClosable=false>



            <template slot="footer">
                <!-- close  -->
                       <a-button size="small" @click="handleCancel">{{ $t('publicLang.Close') }}</a-button>
                <!-- 按钮 adjustDetail 修改 -->
                <a-button  class="mlt" size="small" type="primary"  @click="saveAdjustDetails"    v-if="headerStatus != '00' ? false : true"    :disabled="this.tableData.length > 0 ? this.isShowUpdateAdjDetailBTN : true"  >{{ $t('publicLang.Save') }}</a-button>
                <!-- cancel -->
                <a-popconfirm
                    :title="$t('publicLang.Arecancel')"
                    @confirm="cancelWarehouse"
                    :okText="$t('publicLang.Yes')"
                    :cancelText="$t('publicLang.No')"
                     v-if="headerStatus != '00' ? false : true" 
                >
                  <a-button class="mlt" size="small" type="primary"  v-if="headerStatus != '00' ? false : true"  >{{ $t('publicLang.Cancel') }}</a-button>
                </a-popconfirm>

                <!-- confirm  -->
                <a-popconfirm
                        :title="$t('publicLang.Areconfirm')"
                        @confirm="ConfirmAj"
                        :okText="$t('publicLang.Yes')"
                        :cancelText="$t('publicLang.No')"
                        :disabled="this.tableData.length > 0 ? false : true"
                >
                  <a-button class="mlt" size="small" type="primary" :style= "tableData.size > 0 ? '':'margin-left: 8px;'"  v-if="headerStatus == '00' && this.popupDetailConfirmEnable && (null==this.systemParam.APPROVAL_PROCESS || this.systemParam.APPROVAL_PROCESS!='ADJ')? true : false"   :disabled="this.tableData.length > 0 ? false : true"   >{{ $t('publicLang.Confirm') }}</a-button>
                </a-popconfirm>

                <!-- request approval  -->
                <a-button class="mlt" size="small" type="primary" :style= "tableData.size > 0 ? '':'margin-left: 8px;'" @click="requestApproval"
                          v-if="headerStatus == '00' && this.popupDetailRequestApproval && this.systemParam.APPROVAL_PROCESS=='ADJ'? true : false"   :disabled="this.tableData.length > 0 ? false : true"   >{{ $t('publicLang.requestApproval') }}</a-button>


                <!-- cancel request  -->
                <a-popconfirm
                        :title="$t('publicLang.Arecancel')"
                        @confirm="cancelRequest"
                        :okText="$t('publicLang.Yes')"
                        :cancelText="$t('publicLang.No')"
                        :disabled="this.tableData.length > 0 ? false : true"
                >
                    <a-button class="mlt" size="small" type="primary" :style= "tableData.size > 0 ? '':'margin-left: 8px;'"  v-if="headerStatus == '01' && this.popupDetailCancelRequest && this.systemParam.APPROVAL_PROCESS=='ADJ'? true : false"   :disabled="this.tableData.length > 0 ? false : true"   >{{ $t('publicLang.cancelRequest') }}</a-button>
                </a-popconfirm>

            </template>


            <a-form :form="form">
                <!-- warehouse -->
                    <a-form-item
                         :label="$t('userlang.Warehouse')"
                         :label-col="{ span: 3 }"
                         :wrapper-col="{ span: 8 }">
                        <a-select
                                show-search
                                 optionFilterProp="label"
                                size="small"
                                :disabled="true"
                                :placeholder="$t('publicLang.PleaseSelect')"
                                v-decorator="[
                                'warehouseCode',
                                {
                                  initialValue: warehouseCode,
                                  rules: [{
                                    required: true,
                                    message: $t('publicLang.Required')
                                  }]
                                }
                              ]">
                            <a-select-option :label="item.whsName"  :value="item.whsCode" :key="item.whsCode" v-for="item in wareHouseSelect">{{item.whsName}}</a-select-option>
                        </a-select>
                    </a-form-item>

                <!-- ReasonCode -->
                  <a-form-item
                         :label="$t('pubGicSet.ReasonCode')"
                         :label-col="{ span: 3 }"
                         :wrapper-col="{ span: 8 }">
                        <a-select
                               show-search
                               allowClear
                               optionFilterProp="label"
                                size="small"
                                @change="reasonCodeChange"
                                :placeholder="$t('publicLang.PleaseSelect')"
                                v-decorator="[
                                'reasonCode',
                                {
                                  initialValue: reasonCode,
                                  rules: [{
                                    required: this.reasonMandatory,
                                    message: $t('publicLang.Required')
                                  }]
                                }
                              ]">
                            <a-select-option :label="item.CODE_DESC" :value="item.CODE" :key="item.CODE" v-for="item in reasonCodeSelect">{{item.CODE_DESC}}</a-select-option>
                        </a-select>
                    </a-form-item>

                <!-- Reason Desc  -->
                <a-form-item
                        :label="$t('pubGicSet.Desc')"
                        :label-col="{ span: 3 }"
                        :wrapper-col="{ span: 8 }">
                    <a-input size="small" :placeholder="$t('pubGicSet.Desc')"  v-model="reasonDesc"/>
                </a-form-item>


                <!-- remarks  -->
                    <a-form-item
                            :label="$t('pubGicSet.Remarks')"
                            :label-col="{ span: 3 }"
                            :wrapper-col="{ span: 8 }">
                        <a-textarea size="small" :placeholder="$t('pubGicSet.Remarks')" :rows="3" v-model="remarksVal"/>
                    </a-form-item>
                </a-form>


            <a-row style="float:right;margin-bottom: 10px;">
                <!-- header save -->
                <a-button style="margin-right: 8px" class="mlt" size="small" type="primary" @click="saveAdjustHeader"  v-if="(headerStatus == '01' || headerStatus == '10') ? false : headerStatus == '90' ? false:true ">{{ $t('publicLang.Save')}}</a-button>
                <!-- searsh  -->
                <a-button class="mlt" size="small" type="primary"  @click="addTableItem"   v-if="headerStatus != '00' ? false : true"  >{{ $t('pubGicSet.Search') }}</a-button>
            </a-row>


            <a-divider style="margin: 10px 0px" />
 <!-- :checkbox-config="{trigger: 'row', highlight: true, range: true}" -->
<!-- <vxe-table-column type="checkbox" width="35"></vxe-table-column> -->
   <!-- :sort-config="{multiple: true, trigger: 'cell'}" -->
                     <vxe-table
                        border
                        resizable
                        stripe
                        column-key
                        highlight-hover-column
                        highlight-hover-row
                        highlightCurrentRow
                        show-header-overflow
                        show-overflow
                     
                        :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                        keep-source
                        :keyboard-config="{isArrow: true}"
                        align="center"
                        :data.sync="tableData"
                        class="mytable-style "
                        max-height="350"
                        ref="refAdjDetailTab"
                        size="mini">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                    
                    <vxe-table-column field="uid" title="UID" show-header-overflow="ellipsis" show-overflow="title" :visible="false"></vxe-table-column>
                    <vxe-table-column field="locationCode" :title="$t('pubGicSet.Location')" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="sku" :title="$t('pubGicSet.SKU')" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="logicWhs" :title="$t('pubGicSet.LogicalWH')" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="lpn" :title="$t('pubGicSet.Lpn')" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="expiryDate" :title="$t('batchReceive.ExpiryDate')" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="lotId" :title="$t('pubGicSet.LotID')" show-header-overflow="ellipsis" show-overflow="ellipsis"></vxe-table-column>
                    <vxe-table-column field="avBaseQty" :title="$t('pubGicSet.AvailableQty')" show-header-overflow="ellipsis" show-overflow="ellipsis"></vxe-table-column>

                    <vxe-table-column field="adjQty" :title="$t('pubGicSet.AdjustQty')" show-header-overflow="ellipsis" show-overflow="ellipsis" >
                        <template v-slot="{ row }">
                            <a-input-number :placeholder="$t('pubGicSet.AdjustQty')" :min=1  @change="handleChange" v-model="row.adjQty"  :active-change="false"  size="small" style="width: 100%;"/>
                        </template>
                    </vxe-table-column>

                    <vxe-table-column field="action" width="200" :title="$t('pubGicSet.Action')" show-header-overflow="ellipsis" show-overflow="ellipsis" >
                        <template v-slot="{ row }">
                            <a-select style="width: 100%" v-model="row.action" size="small" :placeholder="$t('publicLang.PleaseSelect')"  @change="handleChange">
                                <a-select-option v-for="item in actionSelect" :key="item.CODE" :value="item.CODE">{{item.CODE_DESC}}</a-select-option>
                            </a-select>
                        </template>
                    </vxe-table-column>


                <vxe-table-column title="Operate" width="150" show-header-overflow="ellipsis" show-overflow="ellipsis"   v-if="headerStatus != '00' ? false : true">
                    <template v-slot="{ row }">
                        <img @click="deleteRows(row)" class='sbxs' style="margin-left: 4px"  src="../../../assets/img/ss-delete.png" width="22" height="22">
                    </template>
                </vxe-table-column>

                </vxe-table>
        </a-modal>
 
        <adjustment-search ref="adjustAdvan" :searTableUid="searTableUid" :adjustParHeaderId="adjustParHeaderId" v-on:getAdjustData="getAdjustData" :ajtype="adjust"></adjustment-search>
    </div>
</template>



<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import adjustmentSearch from './adjustAdvanSearch/adjustmentSearch.vue'
    import {mapState} from "vuex";
    export default {
        components:{  
            adjustmentSearch,
        },
        data(){
            return {
                adjust: 'invAdjDetail',
                visible: false,
                tableData: [],
                form: this.$form.createForm(this),
                reasonCodeSelect:[], // reasonCodeList 下拉数据
                remarksVal: '' ,
                partId: '',
                adjustParHeaderId: '', // save header 返回的id
                actionSelect:[],
                searTableUid: '', // advan search table uid
                reasonCode: "",
                reasonDesc:"",
                headerStatus:'',
                warehouseCode:"",
                wareHouseSelect :[],
                reasonMandatory: false,
                isShowUpdateAdjDetailBTN: true,
                btnFunArr: [
                    {code: 'POP_DTL_Confirm',arr:[]},
                    {code: 'POP_DTL_REQ_APPR',arr:[]},
                    {code: 'POP_DTL_CANCEL_REQ',arr:[]},
                ],
                popupDetailConfirmEnable: false,
                popupDetailRequestApproval:false,
                popupDetailCancelRequest:false,
            }
        },
        computed: {
            ...mapState(["systemParam"]),
            ...mapState(["SF_SCPPrint"]),
            ...mapState(["projectCode"]),
        },
        created(){
            this.init()
        },
       
        methods:{
            handleChange(){
                 let records = this.$refs.refAdjDetailTab.getRecordset();
                 let updateRecords = records.updateRecords
                 if(updateRecords != null && updateRecords.length > 0){
                    this.isShowUpdateAdjDetailBTN = false
                 }else{
                    this.isShowUpdateAdjDetailBTN = true
                 }
            },
            changeQty(row){
            if(row.adjustQty == 0 ){
                 row.adjustQty = 1;
            }
            return   row.adjustQty;
        },
        reasonCodeChange(val){
                this.reasonCode = val
               for(let i in this.reasonCodeSelect){
                   let reasonCode = this.reasonCodeSelect[i].CODE;
                   let reasonDesc = this.reasonCodeSelect[i].CODE_DESC;
                    if (reasonCode == val){
                        this.reasonDesc = reasonDesc
                    }
                }


            },
//            cancel button
            cancelWarehouse(){
                ajax.post(api.CANCELINVADJHEADER,{uid: this.adjustParHeaderId}).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg)
                        this.headerStatus ='10'
                    }else{
                        this.$customMessage.error(res.msg)
                    }
                })
            },
//            confirm button
            ConfirmAj(){
                this.form.validateFields((err, val) => {
                     if (!err) {
                        if(!(this.isShowUpdateAdjDetailBTN)){
                             this.$customMessage.error(this.$t("pubGicSet.DataModifyNotSave"));
                             return;
                        }


                        try{
                            this.checkData(this.tableData);  
                        } catch (error){
                           this.$customMessage.error(error.message);
                           return;
                        }

                        ajax.post(api.INVADJHEADERCONFIRM,{
                             uid: this.adjustParHeaderId,
                            remarks: this.remarksVal,
                            reasonCode: this.reasonCode,
                            reasonDesc: this.reasonDesc
                        }).then(res=>{
                            if(res.code == 200){
                                this.headerStatus = '10'
                                this.$message.success(res.msg)
                            }else{
                                this.$customMessage.error(res.msg)
                            }
                        })
                    }
                })
            },
            requestApproval(){
                this.form.validateFields((err, val) => {
                    if (!err) {
                        if(!(this.isShowUpdateAdjDetailBTN)){
                            this.$customMessage.error(this.$t("pubGicSet.DataModifyNotSave"));
                            return;
                        }
                        try{
                            this.checkData(this.tableData);
                        } catch (error){
                            this.$customMessage.error(error.message);
                            return;
                        }

                        ajax.post(api.INVADJREQUESTAPPROVAL,{
                            uid: this.adjustParHeaderId,
                            remarks: this.remarksVal,
                            reasonCode: this.reasonCode,
                            reasonDesc: this.reasonDesc
                        }).then(res=>{
                            if(res.code == 200){
                                this.headerStatus = '01';
                                this.$message.success(res.msg)
                            }else{
                                this.$customMessage.error(res.msg)
                            }
                        })
                    }
                })
            },
            cancelRequest(){
                this.form.validateFields((err, val) => {
                    if (!err) {
                    /*    if(!(this.isShowUpdateAdjDetailBTN)){
                            this.$customMessage.error(this.$t("pubGicSet.DataModifyNotSave"));
                            return;
                        }
                        try{
                            this.checkData(this.tableData);
                        } catch (error){
                            this.$customMessage.error(error.message);
                            return;
                        }*/
                        ajax.post(api.INVADJCANCELREQUEST,{
                            uid: this.adjustParHeaderId
                        }).then(res=>{
                            if(res.code == 200){
                                this.headerStatus = '90'
                                this.$message.success(res.msg)
                            }else{
                                this.$customMessage.error(res.msg)
                            }
                        })
                    }
                })
            },
//            delete button
            deleteRows(row){
                this.$refs.refAdjDetailTab.remove(row)
                ajax.post(api.DELINVADJDETAIL,{uid: row.uid}).then(res=>{
                 if(res.code == 200){
                        let Records = this.$refs.refAdjDetailTab.getRecordset();
                        let  deleteArr = Records.removeRecords
                        if(deleteArr.length == this.tableData.length){
                            this.tableData = []
                            this.$refs.refAdjDetailTab.remove()
                        }   
                      this.$message.success(res.msg)
                    }else{
                        this.$customMessage.error(res.msg)
                    }
                })
            },

//            初始话table select data
            init(){
                this.headerStatus = ''
                this.adjustParHeaderId = ''
                this.reasonCode=''
                this.reasonDesc=''
                this.remarksVal = ''
                this.warehouseCode = ''
                this.tableData = []
                this.form.resetFields();
                ajax.get(api.USERDROPDOWNWHS).then(res=>{
                    if(res.code == 200){
                        this.wareHouseSelect = res.data.warehouseList
                        this.warehouseCode = res.data.warehouseCode
                    }
                })
                ajax.get(api.INVENTORYREASONCODE).then(res=>{
                    if(res.code == 200){
                     this.actionSelect =res.data.ADJUSTMENT_ACTION;                    
                    //  this.actionSelect.unshift({'CODE':'',"CODE_DESC":""})
                     this.reasonCodeSelect = res.data.ADJUSTMENT_REASON;
                     this.reasonMandatory = res.data.reasonMandatory
                    }
                })
            },
        checkData(array){
           
          
            if(array != null && array.length > 0){
                let errorMsg = '';
                let actionEmpty = '';
                let notEnoughInventory = '';
                for(let i in array){
                     let row = array[i];
                     let sku  = row.sku;
                   
                     if (row.action == null || row.action == '' ||  row.action =='null') {
                         
                        if(actionEmpty.indexOf(sku) > -1){
                            continue;
                        } 
                        if(actionEmpty.length > 0){
                            actionEmpty += ','
                        }
                        actionEmpty += sku
                     }
                     

                     if(row.action == 'ADJUST_OUT' && parseInt(row.adjQty) > row.avBaseQty ){
                       

                         if(notEnoughInventory.indexOf(sku) > -1){
                            continue;
                        } 

                        if(notEnoughInventory.length > 0){
                            notEnoughInventory += ','
                        }
                        notEnoughInventory += sku
                     }
                }     
                
                if(actionEmpty.length > 0){
                    if(errorMsg.length > 0){
                        errorMsg += '\n';
                    }
                    errorMsg += "SKU#"+actionEmpty +" "+this.$t("pubGicSet.ActionCannotBeEmpty");
                } 
                   
                if(notEnoughInventory.length > 0){
                    if(errorMsg.length > 0){
                        errorMsg += '\n';
                    }
                    errorMsg += "SKU#"+notEnoughInventory +" "+this.$t("pubGicSet.NotEnoughInventoryToAdjust");
                 } 
                
                if(errorMsg.length > 0){
                       throw new Error(errorMsg);
                }    
            }
        },
        saveAdjustDetails(){
             let records = this.$refs.refAdjDetailTab.getRecordset();
             let updateRecords = records.updateRecords
             if(updateRecords == null || updateRecords.length == 0){
                this.$customMessage.error(this.$t("pubGicSet.DataNotChange"));
                return;
             }

              try{
                  this.checkData(updateRecords);  
              } catch (error){
                 this.$customMessage.error(error.message);
                 return;
              }
             
        
            ajax.post(api.EDITADJUSTDETAILSAVE,updateRecords).then(res=>{
                if(res.code == 200){
                     this.form.resetFields();
                     this.show2(this.adjustParHeaderId,false);
                   this.$message.success(res.msg);
                }else{
                    this.$customMessage.warning(res.msg);
                }
            })
             

        },

            handleCancel(){
                this.visible = false
                this.headerStatus =''
                this.adjustParHeaderId = ''
                 this.tableData =[]
            },
            show(partId,params){
                this.loadPermission();
                this.partId = partId
                if(params != undefined){
                    ajax.post(api.EDITINVRNTORYINVSAVE,params).then(res=>{
                        if(res.code == 200){
                          let uid =  res.data.uid;
                          this.adjustParHeaderId = uid;
                          this.show2(uid,true);
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }else{
                     this.init();
                      this.visible = true
                }
            },
            show2(uid,init){
                this.loadPermission();
                if(init){this.init(); }
                if(uid != undefined){
                      let params = {'uid' : uid }
                    ajax.get(api.INVENTORYINVADJUETMENTHEADER,params).then(res=>{
                        if(res.code == 200){
                            console.info(res.data)
                            this.headerStatus =  res.data.status
                            this.remarksVal = res.data.remarks
                            this.adjustParHeaderId = res.data.uid
                            this.reasonCode = res.data.reasonCode 
                            this.reasonDesc = res.data.reasonDesc
                            this.searTableUid = res.data.gmcUid
                            this.warehouseCode =  res.data.whsCode
                            this.tableData = res.data.invAdjDetailDtos                                      
                             this.visible = true
                             this.isShowUpdateAdjDetailBTN = true
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }
            },

            loadPermission() {
                let params = {
                    module_code:"ADJUSTMENT"
                }
                ajax.get(api.GENERICPRINTNODEALLBTNFORLOAD, params).then(res=>{
                    this.fieldMap = res.data.fieldMap;
                    let btnMap = res.data.behrMap;

                    if (btnMap != null ) {
                        // 遍历 Map，判断值是否为 null
                        for (let key in  btnMap) {
                            if (btnMap[key] !== null) {
                                for(let i in this.btnFunArr){
                                    if(this.btnFunArr[i].code == key){
                                        this.btnFunArr[i].arr = btnMap[key];
                                    }
                                }
                            }
                        }
                    }

                    console.log(JSON.stringify(this.btnFunArr));
                    const popDtlConfirm = this.btnFunArr.find(item => item.code === 'POP_DTL_Confirm');
                    if (popDtlConfirm && popDtlConfirm.arr.length > 0) {
                        this.popupDetailConfirmEnable = true;
                    }

                    const popDtlRequestApproval = this.btnFunArr.find(item => item.code === 'POP_DTL_REQ_APPR');
                    if (popDtlRequestApproval && popDtlRequestApproval.arr.length > 0) {
                        this.popupDetailRequestApproval = true;
                    }
                    console.log(this.popupDetailRequestApproval.toString());

                    const popDtlCancelRequest = this.btnFunArr.find(item => item.code === 'POP_DTL_CANCEL_REQ');
                    if (popDtlCancelRequest && popDtlCancelRequest.arr.length > 0) {
                        this.popupDetailCancelRequest = true;
                    }

                })
            },

//            header save 提交
            saveAdjustHeader(){
                this.form.validateFields((err,val)=>{
                    if(!err){
                        let params = {
                            uid: this.adjustParHeaderId,
                            remarks: this.remarksVal,
                            reasonCode: val.reasonCode,
                            reasonDesc: this.reasonDesc
                        }
                        ajax.post(api.INVENTORYADJEADER,params).then(res=>{
                            if(res.code == 200){
                                this.adjustParHeaderId = res.data.uid
                                this.searTableUid = res.data.gmcUid
                                this.headerStatus = res.data.status
                                this.$message.success(res.msg)
                           }else{
                                  this.$customMessage.error(res.msg)
                             }
                        })
                    }
                })
            },
            addTableItem(){
                this.$refs.adjustAdvan.show()
            },
            getAdjustData(val){
                this.tableData = val
                for(let i in this.tableData){
                    this.tableData[i].i = i
                }
                 this.isShowUpdateAdjDetailBTN = true
            }
        }
    }
</script>

<style >

</style>